var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.679,
    height: 39.679,
    viewBox: "0 0 39.679 39.679",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4356",
    "data-name": "Group 4356",
    transform: "translate(-634.609 -6418.845)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5534",
    "data-name": "Path 5534",
    d: "M31.007,39.89H8.672A8.673,8.673,0,0,1,0,31.218V8.883A8.673,8.673,0,0,1,8.672.211H31.007a8.673,8.673,0,0,1,8.672,8.672V31.218a8.673,8.673,0,0,1-8.672,8.672",
    transform: "translate(634.609 6418.634)",
    fill: "#202131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5535",
    "data-name": "Path 5535",
    d: "M27.76,13.184l3.151.082V7.532l-4.67-.164A7.946,7.946,0,0,0,18.3,15.314v5.079H12.889v6.144H18.3V39.89h6.8V26.537h4.833l.983-6.144H25.095V15.849a2.665,2.665,0,0,1,2.665-2.665",
    transform: "translate(634.609 6418.634)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebookIcon.28121c628de2524ab5939c3e75cdcc7f.svg";
export { ForwardRef as ReactComponent };